// extracted by mini-css-extract-plugin
module.exports = {"divFloatRight":"styles_divFloatRight__2nc2q","pageHeader":"styles_pageHeader__3mRbm","icon":"styles_icon__37GyR"};